export default function capitalize(value) {
    if (!value) return value;
    value = value.toString();
    value = value.replace('_', ' ');
    return value.charAt(0).toUpperCase() + value.slice(1);
}